import './index.css';
import { jsx } from 'react/jsx-runtime';
import { forwardRef, useMemo } from 'react';
import { TreeSelectorDummy } from './TreeSelectorDummy.js';
import ImmutableSelectionStrategy from './strategy/immutableSelectionStrategy.js';
import { useDisabled } from './useDisabled.js';
import { useSelected } from './useSelected.js';
import '@hh.ru/magritte-common-fuzzy-search';
import '@hh.ru/magritte-ui-breakpoint';
import './ItemsList.js';
import '@tanstack/react-virtual';
import './Item.js';
import 'classnames';
import './ItemContent.js';
import '@hh.ru/magritte-common-keyboard';
import '@hh.ru/magritte-ui-icon/icon';
import './Action.js';
import '@hh.ru/magritte-ui-checkbox-radio';
import './TreeSelectorItemBase.js';
import '@hh.ru/magritte-ui-cell';
import '@hh.ru/magritte-ui-typography';
import './tree-selector-item-rd4snIhP.js';
import './MobileItemsList.js';
import '@hh.ru/magritte-common-func-utils';
import '@hh.ru/magritte-ui-checkable-card/CheckableCardElement';
import './MobileDelimiter.js';
import '@hh.ru/magritte-ui-card';
import './MobileItem.js';
import './MobileParentItem.js';
import '@hh.ru/magritte-ui-badge';
import './TreeSelectorWrapper.js';
import '@hh.ru/magritte-common-use-multiple-refs';
import '@hh.ru/magritte-internal-custom-scroll';
import './collection/treeCollectionHelper.js';
import './collection/treeCollection.js';
import './useExpanded.js';
import './useIndeterminate.js';
import './useRenderInput.js';
import '@hh.ru/magritte-ui-input';
import './useAnimationTimeout.js';
import './strategy/selectionStrategy.js';
import './strategy/createSingleValueToggler.js';
import './strategy/createTreeCollectionToggler.js';
import './strategy/dummyToggle.js';

const TreeSelectorComponent = (props, ref) => {
    const { value, collection, singleChoice, leavesOnly, collapseToParentId, checkSelectable, onChange, disabled, maxSelected, ...rest } = props;
    const strategy = useMemo(() => new ImmutableSelectionStrategy(collection, {
        singleChoice,
        leavesOnly,
        checkSelectable,
    }), [collection, singleChoice, leavesOnly, checkSelectable]);
    if (maxSelected && !collapseToParentId && !leavesOnly) {
        throw new Error(`Magritte component TreeSelector: maxSelected can be used only with collapseToParentId or leavesOnly`);
    }
    const { selected, setSelected } = useSelected({
        value,
        strategy,
        collection,
        onChange,
        maxSelected,
        collapseToParentId,
    });
    const currentDisabled = useDisabled({ selected, disabled, collection, maxSelected });
    return (jsx(TreeSelectorDummy, { ...rest, value: selected, disabled: currentDisabled, collection: collection, singleChoice: singleChoice, leavesOnly: leavesOnly, checkSelectable: checkSelectable, onChange: setSelected, ref: ref }));
};
const TreeSelector = forwardRef(TreeSelectorComponent);

export { TreeSelector };
//# sourceMappingURL=TreeSelector.js.map
